import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import PageNames from "../../config/pageNames";
export default {
  namespaced: true,
  state: {
    csatShimmer: false,
    selectedRating: LocalStorageFunc.getFeedbackOrderObj()?.rating || 0,
    csatTemplateData: {},
    overallFeedback: {},
    food: [],
    delivery: [],
    valueForMoney: [],
    orderDetails: {},
    comments: {
      comment: "",
      raiseTicket: false,
    },
    isNewFeedback: false,
    feedBackData: {},
    feedbackId: "",
    submitFeedBackResponse: {},
    showThankYou: false,
    csatRatingError: false,
    showNpsCsatFeedback: false,
    eventId: "",
    homeWidgetId: "",
    type: "",
    orderId: "",
    items: [],
    sortedItems: [],
    deliveryTimestamp: "",
    userId: "",
    title: "",
    deliveryOrderType: "",
    npsZeroRating: "",
    npsTenRating: "",
    orderNo: 0,
  },
  mutations: {
    updateSelectedRating(state, payload) {
      state.selectedRating = payload;
    },
    updateFeedBackId(state, payload) {
      state.feedbackId = payload;
    },
    updateFeedBackResponse(state, payload) {
      state.submitFeedBackResponse = payload;
    },
    updateCsatTemplateData(state, payload) {
      state.csatTemplateData = payload;
    },
    updateFeedBackData(state, payload) {
      state.feedBackData = payload;
    },
    updateOrderDetails(state, payload) {
      state.orderDetails = payload;
    },
    updateIsNewFeedback(state, payload) {
      state.isNewFeedback = payload;
    },
    updateFoodRating(state, payload) {
      const index = state.food.findIndex(
        (item) => item.productId === payload.productId,
      );

      if (index !== -1) {
        const existing = state.food[index];

        const ratingChanged = existing.rating !== payload.rating;
        const tagsChanged =
          JSON.stringify(existing.tags) !== JSON.stringify(payload.tags);

        if (ratingChanged || tagsChanged) {
          state.food.splice(index, 1, payload);
        }
      } else {
        state.food.push(payload);
      }
    },
    updateDeliveryRating(state, payload) {
      const index = state.delivery.findIndex(
        (item) => item.ratingType === payload.ratingType,
      );

      if (index !== -1) {
        const existing = state.delivery[index];

        const ratingChanged = existing.rating !== payload.rating;
        const tagsChanged =
          JSON.stringify(existing.tags) !== JSON.stringify(payload.tags);

        if (ratingChanged || tagsChanged) {
          state.delivery.splice(index, 1, payload);
        }
      } else {
        state.delivery.push(payload);
      }
    },
    updateValueForMoneyRating(state, payload) {
      const index = state.valueForMoney.findIndex(
        (item) => item.ratingType === payload.ratingType,
      );

      if (index !== -1) {
        const existing = state.valueForMoney[index];

        const ratingChanged = existing.rating !== payload.rating;
        const tagsChanged =
          JSON.stringify(existing.tags) !== JSON.stringify(payload.tags);

        if (ratingChanged || tagsChanged) {
          state.valueForMoney.splice(index, 1, payload);
        }
      } else {
        state.valueForMoney.push(payload);
      }
    },
    updateComment(state, payload) {
      state.comments.comment = payload;
    },
    updateRaiseTicket(state, payload) {
      state.comments.raiseTicket = payload;
    },
    updateThankYou(state, payload) {
      state.showThankYou = payload;
    },
    updateCsatRatingError(state, payload) {
      state.csatRatingError = payload;
    },
    updateNpsCsatModalFlag(state, payload) {
      state.showNpsCsatFeedback = payload;
    },
    updateItems(state, payload) {
      state.items = payload;
    },
    updateFeedbackType(state, payload) {
      state.type = payload;
      commit("sortItems", payload);
    },
    updateData(state, payload) {
      const { order = {} } = payload;
      state.eventId = payload?.eventId || "";
      state.homeWidgetId = payload?.homeWidgetId || "";
      state.type = payload?.type || "";
      state.userId = payload?.userId || "";
      if (order?.items?.length > 0) {
        let { items = [], deliveryTimeStamp = "" } = order;
        state.items = items.sort((a, b) => b.price - a.price);
        state.deliveryTimestamp = deliveryTimeStamp;
      }
      state.title = payload?.title || "";
      state.orderId = payload?.orderId;
      state.orderNo = payload?.order?.store.orderId;
      state.deliveryOrderType =
        payload?.order?.deliveryOrderType?.deliveryTypeCode || "";
      state.npsZeroRating = payload?.npsZeroRating || "";
      state.npsTenRating = payload?.npsTenRating || "";
    },
  },
  actions: {
    csatFeedbackApi({ commit, state, getters }, payload) {
      ApiCalls.CSAT_FEEDBACK_API({
        headers: {
          ...Headers(),
        },
        payload: {
          orderId: Utility.getParamDataFromUrl("id"),
          type: Utility.getParamDataFromUrl("utm_source"),
          orderMode: Utility.getParamDataFromUrl("orderMode"),
        },
      })
        .then(function (response) {
          if (response?.errors?.length) {
            commit("ErrorModal/updateErrorModalOpen", true, {
              root: true,
            });
            const errData = {
              message: response?.errors[0]?.message || "Something went wrong!",
              headerText: "Alert",
              rightCTAText: "Ok",
              leftCTAText: "Ok",
              handleClick: "login",
            };
            commit("ErrorModal/updateErrorContent", errData, {
              root: true,
            });
          }
          commit("updateOrderDetails", response?.data?.orderDetails);
          const feedbackObject = {};
          const feedbackData = response?.data?.template;
          for (const key in feedbackData) {
            const type = feedbackData[key].type.toLowerCase();
            feedbackObject[type] = feedbackData[key];
          }
          if (response?.data?.feedback) {
            commit("updateIsNewFeedback", false);
            commit("updateFeedBackData", response?.data?.feedback);
            commit("updateFeedBackId", response?.data?.feedback?.id);
            if (response?.data?.feedback?.overall?.rating) {
              commit(
                "updateSelectedRating",
                response?.data?.feedback?.overall?.rating,
              );
            }
          } else {
            commit("updateIsNewFeedback", true);
          }
          commit("updateCsatTemplateData", feedbackObject);
        })
        .catch({});
    },
    submitCsatFeedbackApi({ commit, state, getters }, payload) {
      commit("updateCsatRatingError", false);
      const orderMode = Utility.getParamDataFromUrl("orderMode");
      const headers = Headers();
      let payloadObj = {
        comments: state.comments,
        orderId:
          LocalStorageFunc.getFeedbackOrderObj()?.csatOrderId ||
          Utility.getParamDataFromUrl("id"),
        mobile: payload?.mobile,
        userId:
          orderMode == "OFFLINE" || orderMode == "ONLINE"
            ? localStorage.userInfo &&
              Utility.tryJsonParse(localStorage.userInfo)?.userData?.mobile
              ? Utility.tryJsonParse(localStorage.userInfo)?.userData?.mobile
              : payload?.mobile
            : headers.userid,
        storeId: headers.storeId,
        type: "CSAT",
        source: headers.source,
        orderType: headers.orderType,
        orderMode: orderMode,
      };
      if (state.selectedRating) {
        payloadObj = {
          ...payloadObj,
          overall: {
            rating: state.selectedRating,
          },
        };
      }
      if (state.food && state.food.length) {
        payloadObj = {
          ...payloadObj,
          food: state.food,
        };
      }
      if (state.delivery && state.delivery.length) {
        payloadObj = {
          ...payloadObj,
          deliveryRatings: state.delivery,
        };
      }
      if (state.valueForMoney && state.valueForMoney.length) {
        payloadObj = {
          ...payloadObj,
          valueForMoney: state.valueForMoney,
        };
      }
      if (
        !payloadObj?.overall?.rating &&
        !payloadObj?.food &&
        !payloadObj?.deliveryRatings &&
        !payloadObj?.valueForMoney &&
        !state.comments?.comment
      ) {
        commit("updateCsatRatingError", true);
        setTimeout(() => {
          commit("updateCsatRatingError", false);
        }, 3000);
        return;
      }

      ApiCalls.SUBMIT_CSAT_FEEDBACK_API({
        headers: {
          ...Headers(),
        },
        payload: payloadObj,
      })
        .then(function (response) {
          if (response?.errors?.length) {
            commit("ErrorModal/updateErrorModalOpen", true, {
              root: true,
            });
            const errData = {
              message: response?.errors[0]?.message || "Something went wrong!",
              headerText: "Alert",
              rightCTAText: "Ok",
              leftCTAText: "Ok",
            };
            commit("ErrorModal/updateErrorContent", errData, {
              root: true,
            });
          } else {
            commit("updateFeedBackResponse", response);
            commit("updateFeedBackId", response?.data?.id);
            commit("updateThankYou", true);
          }
        })
        .catch({});
    },
    updateCsatFeedbackApi({ commit, state, getters }, payload) {
      commit("updateCsatRatingError", false);
      const orderMode = Utility.getParamDataFromUrl("orderMode");
      const headers = Headers();
      let payloadObj = {
        comments: state.comments,
        orderId: LocalStorageFunc.getFeedbackOrderObj()?.csatOrderId,
        mobile: payload?.mobile,
        userId: headers.userid,
        storeId: headers.storeId,
        type: "CSAT",
        source: headers.source,
        orderType: headers.orderType,
        orderMode: orderMode,
      };

      if (state.food && state.food.length) {
        payloadObj = {
          ...payloadObj,
          food: state.food,
        };
      }
      if (state.delivery && state.delivery.length) {
        payloadObj = {
          ...payloadObj,
          deliveryRatings: state.delivery,
        };
      }
      if (state.valueForMoney && state.valueForMoney.length) {
        payloadObj = {
          ...payloadObj,
          valueForMoney: state.valueForMoney,
        };
      }
      if (
        !payloadObj?.food &&
        !payloadObj?.deliveryRatings &&
        !payloadObj?.valueForMoney &&
        !state.comments?.comment
      ) {
        commit("updateCsatRatingError", true);
        setTimeout(() => {
          commit("updateCsatRatingError", false);
        }, 3000);
        return;
      }

      ApiCalls.UPDATE_CSAT_FEEDBACK_API({
        headers: {
          ...Headers(),
        },
        payload: { data: { csat: payloadObj }, feedbackId: state.feedbackId },
      })
        .then(function (response) {
          if (response?.errors?.length) {
            commit("ErrorModal/updateErrorModalOpen", true, {
              root: true,
            });
            const errData = {
              message: response?.errors[0]?.message || "Something went wrong!",
              headerText: "Alert",
              rightCTAText: "Ok",
              leftCTAText: "Ok",
            };
            commit("ErrorModal/updateErrorContent", errData, {
              root: true,
            });
          } else {
            commit("updateFeedBackResponse", response);
            commit("updateFeedBackId", response?.data?.id);
            commit("updateThankYou", true);
          }
        })
        .catch({});
    },
    submitCsatAdditionalFeedbackApi({ commit, state, getters }, payload) {
      const { tag, tags, csatId } = payload;
      ApiCalls.SUBMIT_CSAT_ADDITIONAL_FEEDBACK_API({
        headers: {
          ...Headers(),
        },
        payload: {
          data: { ratedTags: [tag], tags },
          feedbackId: csatId || state?.feedbackId,
        },
      })
        .then(function (response) {
          if (response?.errors?.length) {
            commit("ErrorModal/updateErrorModalOpen", true, {
              root: true,
            });
            const errData = {
              message: response?.errors[0]?.message || "Something went wrong!",
              headerText: "Alert",
              rightCTAText: "Ok",
              leftCTAText: "Ok",
            };
            commit("ErrorModal/updateErrorContent", errData, {
              root: true,
            });
          } else {
            if (
              LocalStorageFunc.getSessionStorageKey("screenName") ===
              PageNames.ORDERHISTORY_PAGE
            ) {
              Utility.sendToOrderHistory();
            } else {
              Utility.sendToHomepageScreen();
            }
          }
        })
        .catch({});
    },
    getHomeWidget({ commit }, payload) {
      ApiCalls.GET_NPS_CSAT_HOME_WIDGET({
        headers: {
          ...Headers(),
          mobile: payload.mobile,
        },
      })
        .then((res) => {
          if (res?.data) {
            const data = res?.data || {};
            if (Object.keys(data).length > 0) {
              commit("updateData", data);
              commit("updateNpsCsatModalFlag", true);
              if (
                data?.orderId &&
                !LocalStorageFunc.getNpsFiredOrderIds().includes(data.orderId)
              ) {
                commit("OrderTracking/addNpsFiredOrderId", data.orderId, {
                  root: true,
                });
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    dismissHomeWidget({ commit }, payload) {
      ApiCalls.NPS_CSAT_DISMISS_HOME_WIDGET({
        headers: Headers(),
        payload: payload,
      })
        .then()
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
